import BaseApi from "../../BaseApi";
import {headers} from "../../ApiSettings";

class Utility extends BaseApi {
    constructor() {
        super({suffix: ""});
    }

    GetKhedmatSys(params){
        return this.httpService.get("Definition/khedmat-sys",{headers,params})
    }

    GetAllKhedmat(params){
        return this.httpService.get("Definition/all-khadamat",{headers,params})
    }

    InsertKhedmatData(data){
        return this.httpService.post("Definition/insert-khadamat",data,{headers})
    }

    EditPriceKhedmat(data){
        return this.httpService.put("Definition/set-price-khedmat",data,{headers})
    }

    EditKhedmatAction(data){
        return this.httpService.put("Definition/update-khadamat",data,{headers})
    }

    deleteKhedmat(data){
        return this.httpService.delete("Definition/delete-khadamat",{headers,data})
    }

    disableKhadamat(data){
        return this.httpService.put("Definition/disable-khadamat",data,{headers})
    }
}
const utilityService = new Utility();
export default utilityService;


